export default [
  {
    path: '/getting-started',
    name: 'GettingStarted',
    component: () => import(/* webpackChunkName: "getting-started" */ '@app2/modules/GettingStarted/Page/Index.vue'),
  }
]